// src/components/common/DashboardControls.js
import React from 'react';
import { format, subDays, subMonths, subYears } from 'date-fns';

const DashboardControls = ({
  timeRange,
  setTimeRange,
  dataAggregation,
  setDataAggregation,
  customDateRange,
  setCustomDateRange,
  autoRefresh,
  setAutoRefresh,
  refreshInterval,
  setRefreshInterval,
  isLoading,
  handleManualRefresh,
  editMode,
  toggleEditMode
}) => {
  
  const handleRangeChange = (e) => {
    setTimeRange(e.target.value);
  };

  const handleAggregationChange = (e) => {
    setDataAggregation(e.target.value);
  };

  const handleCustomDateChange = (e, field) => {
    setCustomDateRange({
      ...customDateRange,
      [field]: e.target.value
    });
  };

  const handleRefreshIntervalChange = (e) => {
    setRefreshInterval(parseInt(e.target.value, 10));
  };

  const toggleAutoRefreshSetting = () => {
    setAutoRefresh(!autoRefresh);
  };
  
  return (
    <div className="mb-3 bg-white p-3 rounded shadow-sm">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2 className="fs-5 fw-bold mb-0">Dashboard Sensori</h2>
        <div className="d-flex gap-2">
          <button 
            onClick={toggleEditMode} 
            className={`btn btn-sm ${editMode ? 'btn-primary' : 'btn-outline-secondary'}`}
            title={editMode ? "Esci dalla modalità modifica" : "Modifica nomi e ordine sensori"}
          >
            <i className="bi bi-pencil-square"></i>
          </button>
          <button 
            onClick={handleManualRefresh} 
            className="btn btn-sm btn-outline-primary d-flex align-items-center" 
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                <span className="d-none d-sm-inline">Aggiornamento...</span>
              </>
            ) : (
              <>
                <i className="bi bi-arrow-clockwise me-1"></i>
                <span className="d-none d-sm-inline">Aggiorna</span>
              </>
            )}
          </button>
        </div>
      </div>
      
      {/* Menu a fisarmonica per i controlli su mobile */}
      <div className="accordion mb-3" id="settingsAccordion">
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button className="accordion-button collapsed py-2" type="button" data-bs-toggle="collapse" data-bs-target="#filtersCollapse">
              Filtri e opzioni
            </button>
          </h2>
          <div id="filtersCollapse" className="accordion-collapse collapse" data-bs-parent="#settingsAccordion">
            <div className="accordion-body">
              <div className="row g-2">
                <div className="col-6">
                  <label className="form-label small mb-1">Periodo</label>
                  <select 
                    value={timeRange} 
                    onChange={handleRangeChange}
                    className="form-select form-select-sm"
                  >
                    <option value="day">Ultime 24h</option>
                    <option value="week">Ultima settimana</option>
                    <option value="month">Ultimo mese</option>
                    <option value="year">Ultimo anno</option>
                    <option value="all">Tutti i dati</option>
                    <option value="custom">Personalizzato</option>
                  </select>
                </div>
                
                <div className="col-6">
                  <label className="form-label small mb-1">Aggregazione</label>
                  <select 
                    value={dataAggregation} 
                    onChange={handleAggregationChange}
                    className="form-select form-select-sm"
                  >
                    <option value="none">Nessuna</option>
                    <option value="hourly">Oraria</option>
                    <option value="daily">Giornaliera</option>
                  </select>
                </div>
                
                {timeRange === 'custom' && (
                  <>
                    <div className="col-6">
                      <label className="form-label small mb-1">Da</label>
                      <input 
                        type="date" 
                        className="form-control form-control-sm" 
                        value={customDateRange.startDate}
                        onChange={(e) => handleCustomDateChange(e, 'startDate')}
                      />
                    </div>
                    <div className="col-6">
                      <label className="form-label small mb-1">A</label>
                      <input 
                        type="date" 
                        className="form-control form-control-sm" 
                        value={customDateRange.endDate}
                        onChange={(e) => handleCustomDateChange(e, 'endDate')}
                      />
                    </div>
                  </>
                )}
                
                <div className="col-12 mt-2">
                  <div className="form-check form-switch">
                    <input 
                      className="form-check-input" 
                      type="checkbox" 
                      id="autoRefreshSwitch" 
                      checked={autoRefresh}
                      onChange={toggleAutoRefreshSetting}
                    />
                    <label className="form-check-label small" htmlFor="autoRefreshSwitch">
                      Auto-refresh {autoRefresh ? 'attivo' : 'disattivato'}
                    </label>
                  </div>
                </div>
                
                {autoRefresh && (
                  <div className="col-12">
                    <label className="form-label small mb-1">Intervallo refresh</label>
                    <select 
                      className="form-select form-select-sm" 
                      value={refreshInterval}
                      onChange={handleRefreshIntervalChange}
                    >
                      <option value="10">10 secondi</option>
                      <option value="30">30 secondi</option>
                      <option value="60">1 minuto</option>
                      <option value="300">5 minuti</option>
                    </select>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardControls;